import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RR_TABLE_PAGINATION_POSITION } from '../../../common/enum/table/position.enum';
import { RRITablePaginationSettings } from '../../../common/interfaces/table/table-pagination-settings.interface';

@Component({
  selector: 'rr-table-pagination',
  templateUrl: './table-pagination.component.html',
  styleUrls: ['./table-pagination.component.scss'],
})
export class TablePaginationComponent {
  public modifiedTableClass: string;
  public itemsPerPage: number;

  @Input() model: RRITablePaginationSettings;
  @Input() position: RR_TABLE_PAGINATION_POSITION;
  @Output() changedPage: EventEmitter<number> = new EventEmitter();
  @Output() changePageSize: EventEmitter<number> = new EventEmitter();

  constructor() {
    this.modifiedTableClass = '';
  }

  getPaginationContainerClass() {
    const positionClass =
      this.position === RR_TABLE_PAGINATION_POSITION.TOP
        ? 'top-pagination'
        : 'bottom-pagination';

    return this.modifiedTableClass.indexOf('table-small') > -1
      ? positionClass
      : `${positionClass} pagination-large`;
  }

  showItemsPerPage() {
    if (
      this.model.showItemsPerPageOn === RR_TABLE_PAGINATION_POSITION.NONE ||
      this.model.showItemsPerPageOn !== this.position
    ) {
      return false;
    }

    return true;
  }

  pageChanged(event: { page: number; itemsPerPage: number }) {
    if (this.model.settings.currentPage != Number(event.page)) {
      this.model.settings.currentPage = Number(event.page);
      this.changedPage.emit(this.model.settings.currentPage);
    }
  }

  changeShowItemsPerPage(event: number) {
    this.itemsPerPage = event;
    this.changePageSize.emit(event);
  }

  getRecordsCount() {
    if (
      !this.model ||
      !this.model.settings ||
      !this.model.settings.currentPage ||
      !this.model.settings.pageSize ||
      !this.model.settings.recordCount
    ) {
      return '0 of 0';
    }
    const startvalue =
      (this.model.settings.currentPage - 1) * this.model.settings.pageSize + 1;
    const endvalue =
      this.model.settings.currentPage * this.model.settings.pageSize;

    return `${startvalue}-${endvalue} of ${this.model.settings.recordCount}`;
  }

  showRecordsCount() {
    if (this.model && this.model.settings.recordCount) {
      return true;
    } else {
      return false;
    }
  }
}
